export default __webpack_public_path__ + "static/media/before@2x.16dcabb1.png";